export default __webpack_public_path__ + "static/product-dots-blurred-74b8d35d5cc9502e6a1abbe27b96430a.jpg";